import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TwitterReplyField, TwitterRetweetField } from 'components/SocialPreviews';
import * as styles from './TwitterComment.scss';
var TwitterComment = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(TwitterComment, _Component);

  var _super = _createSuper(TwitterComment);

  function TwitterComment(props) {
    var _this;

    _classCallCheck(this, TwitterComment);

    _this = _super.call(this, props);
    _this.state = {
      showReplyArea: false,
      showRetweetArea: false
    };
    return _this;
  }

  _createClass(TwitterComment, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          avatarUrl = _this$props.avatarUrl,
          conversationId = _this$props.conversationId,
          datetime = _this$props.datetime,
          handle = _this$props.handle,
          image = _this$props.image,
          numLikes = _this$props.numLikes,
          numRetweets = _this$props.numRetweets,
          numReplies = _this$props.numReplies,
          parentHandle = _this$props.parentHandle,
          text = _this$props.text,
          tweetId = _this$props.tweetId,
          username = _this$props.username;
      var commentWrapStyle = {};

      if (this.state.showReplyArea) {
        commentWrapStyle = {
          marginTop: 8,
          paddingBottom: 0,
          paddingTop: 0,
          borderBottom: 0,
          borderRadius: 18,
          boxShadow: '0 0 8px 2px rgba(0,0,0,0.25)'
        };
      } else if (this.state.showRetweetArea) {
        commentWrapStyle = {
          paddingTop: 0,
          borderBottom: 0,
          borderRadius: 18,
          boxShadow: '0 0 8px 2px rgba(0,0,0,0.25)'
        };
      }

      var filteredText = text ? text.replace("".concat(parentHandle, " "), '') : '';
      var tweetBody = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.profileRow,
        style: this.state.showRetweetArea ? {
          margin: 20,
          marginBottom: 10
        } : {}
      }, /*#__PURE__*/React.createElement("img", {
        className: styles.profileImg,
        src: avatarUrl
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.profileRowText
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: styles.username
      }, username), /*#__PURE__*/React.createElement("span", {
        className: styles.handle
      }, handle, /*#__PURE__*/React.createElement("span", {
        className: styles.bullet
      }, "\u2022"), /*#__PURE__*/React.createElement("span", {
        className: styles.datetime
      }, datetime))), !this.state.showRetweetArea && /*#__PURE__*/React.createElement("div", {
        className: styles.parentHandle
      }, "Replying to ", parentHandle), /*#__PURE__*/React.createElement("div", {
        className: styles.text
      }, filteredText))));
      return /*#__PURE__*/React.createElement("div", {
        className: styles.commentWrap,
        style: commentWrapStyle
      }, this.state.showRetweetArea && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.inputWrap
      }, /*#__PURE__*/React.createElement(TwitterRetweetField, {
        tweetId: tweetId,
        item: {
          text: text,
          username: username
        },
        closeField: function closeField() {
          return _this2.setState({
            showRetweetArea: false
          });
        },
        tweetBody: tweetBody
      }))), this.state.showReplyArea && /*#__PURE__*/React.createElement("h3", {
        className: styles.replyHeader
      }, "Reply to ", username, /*#__PURE__*/React.createElement("span", {
        className: styles.closeBtn,
        onClick: function onClick() {
          return _this2.setState({
            showReplyArea: false
          });
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-close-empty ".concat(styles.closeIcon)
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.innerWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.bodyWrap
      }, !this.state.showRetweetArea && tweetBody, image && !this.state.showReplyArea && !this.state.showRetweetArea && /*#__PURE__*/React.createElement("img", {
        src: image,
        className: styles.mediaImg
      }), !this.state.showReplyArea && !this.state.showRetweetArea && /*#__PURE__*/React.createElement("div", {
        className: styles.iconRow
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.iconWrap,
        onClick: function onClick() {
          return _this2.setState({
            showReplyArea: !_this2.state.showReplyArea
          });
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-comment-o ".concat(styles.replies, " ").concat(styles.twIcon)
      })), /*#__PURE__*/React.createElement("span", {
        className: styles.iconWrap,
        onClick: function onClick() {
          return _this2.setState({
            showRetweetArea: !_this2.state.showRetweetArea
          });
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-retweet ".concat(styles.twIcon, " ").concat(styles.retweets)
      })), /*#__PURE__*/React.createElement("span", {
        className: styles.iconWrap
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-heart-o ".concat(styles.twIcon, " ").concat(styles.hearts)
      }))))), this.state.showReplyArea && /*#__PURE__*/React.createElement("div", {
        className: styles.inputWrap
      }, /*#__PURE__*/React.createElement(TwitterReplyField, {
        tweetId: tweetId,
        conversationId: conversationId,
        item: {
          text: text,
          username: username
        },
        closeField: function closeField() {
          return _this2.setState({
            showReplyArea: false
          });
        }
      })));
    }
  }]);

  return TwitterComment;
}(Component), _defineProperty(_class2, "defaultProps", {
  avatarUrl: 'https://likeabucket.s3.amazonaws.com/user_upload/0/B1fQZu4bW.png',
  conversationId: 0,
  handle: '@commenter',
  datetime: 'Jun 5',
  numLikes: 2,
  numReplies: 4,
  numRetweets: 14,
  parentHandle: '@likeablelocal',
  text: 'This is my reply to your great, fascinating Tweet.',
  tweetId: 0,
  username: 'Commenter Name'
}), _temp)) || _class);
export default TwitterComment;